import LoyaltyPoints from "./LoyaltyPoints";
import Notifications from "./Notifications";
import BranchesUsers from "./BranchesUsers";
import BranchCreate from "./BranchCreate";
import BranchEdit from "./BranchEdit";
import UserCreate from "./UserCreate";
import UserEdit from "./UserEdit";
import WishList from "./WishList";
import Wallet from "./Wallet";
import StoreProfile from "./StoreProfile";
import ChangePassword from "./ChangePassword";
import InstructionalVideos from "./InstructionalVideos";

const Profile = {
  LoyaltyPoints,
  Notifications,
  BranchesUsers,
  BranchCreate,
  BranchEdit,
  UserCreate,
  UserEdit,
  WishList,
  Wallet,
  StoreProfile,
  ChangePassword,
  InstructionalVideos
}

export default Profile;
